import { autoinject, observable } from 'aurelia-framework';
import { IState, LocationState } from "../store/state";
import { Store } from "aurelia-store";
import { updateLocationState } from "../store/actions/location-actions";
import { Location } from "../models/location";

@autoinject
export class LocationManagement {
	selectLabel: string;
	locationState: LocationState;
	@observable selectAll: boolean;
	private subscription: any;
	constructor(private readonly store: Store<IState>) {
		this.selectLabel = "Select All";
	}

	bind() {

		this.subscription = this.store.state.subscribe((state) => {
			this.locationState = Object.assign({}, state.locationState);
			this.selectAll = this.locationState.locations.length === this.locationState.selectedLocations.length;
		});
	}
	unbind() {
		this.subscription.unsubscribe();
	}

	selectedLocationsChanged() {
		this.selectAll = this.locationState.locations.length === this.locationState.selectedLocations.length;
	}

	selectAllChanged(newValue, oldValue) {
		if (oldValue === undefined) {
			return;
		}

		if (newValue === false) {
			this.locationState.selectedLocations = new Array<Location>();
		} else {
			this.locationState.selectedLocations = new Array<Location>();
			for (let i = 0; i < this.locationState.locations.length; i++) {
				this.locationState.selectedLocations[i] = this.locationState.locations[i];
			}
		}

	}

	locationMatcher = (a: Location, b: Location) => a.code === b.code;
	
	acceptChanges() {
		this.store.dispatch(updateLocationState, this.locationState);
	}
	async acceptChangesAsync() {
		await this.store.dispatch(updateLocationState, this.locationState);
	}

}